import { atom } from "recoil";

export const freezePopUpAtom = atom({
  key: "freezePopUp",
  default: false,
});
